'use client'

import { Button } from '@vinted/web-ui'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useSession } from '@marketplace-web/shared/session-data'
import { toUrlQuery } from '@marketplace-web/shared/utils'

import { clickEvent } from '@marketplace-web/header/header-data'
import { useSelectTypeUrl } from '@marketplace-web/registration/identity-feature'
import { useAbTest } from '@marketplace-web/feature-flags/ab-tests-data'

import { ITEM_UPLOAD_URL, SIGNUP_URL } from '../../constants/routes'

const HeaderUploadItem = () => {
  const { user } = useSession()
  const userId = user?.id

  const translate = useTranslate()
  const { track } = useTracking()
  const isNonNativeFlowAbTestEnabled = useAbTest('non_native_flow')?.variant === 'on'
  const selectTypeUrl = useSelectTypeUrl()
  const authenticationUrl = isNonNativeFlowAbTestEnabled ? selectTypeUrl : SIGNUP_URL

  function handleAnchorClick() {
    track(clickEvent({ target: 'upload_item' }))
  }

  return (
    <Button
      text={translate('header.actions.upload_item')}
      styling={Button.Styling.Filled}
      size={Button.Size.Small}
      url={
        userId
          ? ITEM_UPLOAD_URL
          : `${authenticationUrl}?${toUrlQuery({ ref_url: ITEM_UPLOAD_URL })}`
      }
      rel="nofollow"
      onClick={handleAnchorClick}
    />
  )
}

export default HeaderUploadItem
